class ProductRecommendations extends HTMLElement {
  initialize() {
    const url = this.dataset.url;
    if (!url) return console.warn('⚠️ No data-url found on product-recommendations element.');

    console.log('🔗 Fetching complementary products from:', url);

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log('📦 Data received:', data);
        if (!data?.products?.length) {
          this.innerHTML = `<p>No complementary products found.</p>`;
          return;
        }

        this.innerHTML = `
          <ul class="complementary-products__list list-unstyled grid grid--2-col-tablet grid--4-col-desktop">
            ${data.products
              .map((p) => {
                const img =
                  (p.featured_image?.startsWith('//') ? 'https:' : '') +
                  (p.featured_image || '');
                const price = p.price ? `$${(p.price / 100).toFixed(2)}` : '';
                return `
                  <li class="complementary-card grid__item">
                    <a href="${p.url}" class="complementary-card__link">
                      <img src="${img}" alt="${p.title}" loading="lazy" />
                      <h3>${p.title}</h3>
                      ${price ? `<p>${price}</p>` : ''}
                    </a>
                  </li>`;
              })
              .join('')}
          </ul>`;
      })
      .catch((err) => console.error('💥 Error fetching recommendations:', err));
  }

  connectedCallback() {
    // Sometimes Shopify dynamically replaces the element, so delay initialization
    requestAnimationFrame(() => this.initialize());
  }
}

// Define the custom element only once
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

// Also reinitialize if Shopify re-renders the section
document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('product-recommendations').forEach((el) => {
    if (el instanceof ProductRecommendations) {
      el.initialize();
    }
  });
});
